module.exports = __webpack_public_path__ + "img/SK.2aaa4484.svg";